// 权限数据管理
const requestBaseData = {
  code: 0,
  reasonCode: 0,
  requestId: '1234567890',
  msg: 'success',
  time: new Date().getTime(),
  requiredVersion: {
    merchantWeb: '1.0.0',
    clientWeb: '1.0.0',
  },
};
export const settingMockResponses = {
  '/api/brand/v1/shop/getShopSettings': {
    ...requestBaseData,
    data: {
      shopId: 0,
      settings: {
        selectedLanguagesList: {
          itemId: 0,
          itemName: 'selectedLanguagesList',
          itemValue: '["en", "ja"]',
          langCode: 'en',
        },
        displayChatWidget: {
          itemId: 1,
          itemName: 'displayChatWidget',
          itemValue: 'true',
          langCode: 'en',
        },
        brandLogo: {
          itemId: 2,
          itemName: 'brandLogo',
          itemValue: 'https://example.com/logo.png',
          langCode: 'en',
        },
        widgetHeading: {
          itemId: 3,
          itemName: 'widgetHeading',
          itemValue: '你好我是TITLE',
          langCode: 'en',
        },
        widgetDescription: {
          itemId: 3,
          itemName: 'widgetDescription',
          itemValue: 'Need help? Contact us or explore our helpful articles for support!',
          langCode: 'en',
        },
        emailUsSwitch: { itemId: 4, itemName: 'emailUsSwitch', itemValue: 'true', langCode: 'en' },
        emailUsReceiveEmailAddress: {
          itemId: 5,
          itemName: 'emailUsReceiveEmailAddress',
          itemValue: 'support@example.com',
          langCode: 'en',
        },
        orderTrackSwitch: {
          itemId: 6,
          itemName: 'orderTrackSwitch',
          itemValue: 'true',
          langCode: 'en',
        },
        orderTrackConfig: {
          itemId: 7,
          itemName: 'orderTrackConfig',
          itemValue: '{"type": 1, "value": "ParcelPanel"}',
          langCode: 'en',
        },
        widgetThemeColor: {
          itemId: 8,
          itemName: 'widgetThemeColor',
          itemValue: '#4A90E2',
          langCode: 'en',
        },
        widgetTextColor: {
          itemId: 9,
          itemName: 'widgetTextColor',
          itemValue: '#FFFFFF',
          langCode: 'en',
        },
        launcherType: { itemId: 9, itemName: 'launcherType', itemValue: '1', langCode: 'en' },
        launcherIcon: {
          itemId: 10,
          itemName: 'launcherIcon',
          itemValue: '{"type": 3, "value": "https://example.com/logo.png"}',
          langCode: 'en',
        },
        launcherText: { itemId: 11, itemName: 'launcherText', itemValue: 'Help', langCode: 'en' },
        launcherButtonSize: {
          itemId: 11,
          itemName: 'launcherButtonSize',
          itemValue: '1',
          langCode: 'en',
        },
        launcherArrangement: {
          itemId: 12,
          itemName: 'launcherArrangement',
          itemValue: 'right',
          langCode: 'en',
        },
        launcherBottom: { itemId: 13, itemName: 'launcherBottom', itemValue: '20', langCode: 'en' },
        launcherSpacing: {
          itemId: 14,
          itemName: 'launcherSpacing',
          itemValue: '20',
          langCode: 'en',
        },
        widgetLanguageSwitcher: {
          itemId: 14,
          itemName: 'widgetLanguageSwitcher',
          itemValue: 'true',
          langCode: 'en',
        },
        widgetDefaultLanguage: {
          itemId: 15,
          itemName: 'widgetDefaultLanguage',
          itemValue: 'en',
          langCode: 'en',
        },
        widgetTranslationLanguage: {
          itemId: 16,
          itemName: 'widgetTranslationLanguage',
          itemValue: 'en',
          langCode: 'en',
        },
        widgetNavigationHome: {
          itemId: 17,
          itemName: 'widgetNavigationHome',
          itemValue: 'Home',
          langCode: 'en',
        },
        widgetNavigationTracking: {
          itemId: 17,
          itemName: 'widgetNavigationTracking',
          itemValue: 'Tracking',
          langCode: 'en',
        },
        widgetContactUsTitle: {
          itemId: 18,
          itemName: 'widgetContactUsTitle',
          itemValue: 'Contact us',
          langCode: 'en',
        },
        widgetContactEmailUsButton: {
          itemId: 19,
          itemName: 'widgetContactEmailUsButton',
          itemValue: 'Email us',
          langCode: 'en',
        },
        emailUsIntroduce: {
          itemId: 20,
          itemName: 'emailUsIntroduce',
          itemValue: 'Introduce yourself',
          langCode: 'en',
        },
        emailUsFirstName: {
          itemId: 20,
          itemName: 'emailUsFirstName',
          itemValue: 'First name',
          langCode: 'en',
        },
        emailUsLastName: {
          itemId: 21,
          itemName: 'emailUsLastName',
          itemValue: 'Last name',
          langCode: 'en',
        },
        emailUsEmailAddress: {
          itemId: 22,
          itemName: 'emailUsEmailAddress',
          itemValue: 'Email',
          langCode: 'en',
        },
        emailUsDetails: {
          itemId: 22,
          itemName: 'emailUsDetails',
          itemValue: 'Details',
          langCode: 'en',
        },
        emailUsDetailsReminder: {
          itemId: 23,
          itemName: 'emailUsDetailsReminder',
          itemValue: 'Use Ctrl+Enter to add a line',
          langCode: 'en',
        },
        emailUsAttach: {
          itemId: 24,
          itemName: 'emailUsAttach',
          itemValue: 'Attach files',
          langCode: 'en',
        },
        emailUsSubmitButton: {
          itemId: 25,
          itemName: 'emailUsSubmitButton',
          itemValue: 'Submit',
          langCode: 'en',
        },
        emailUsSubmitSuccess: {
          itemId: 25,
          itemName: 'emailUsSubmitSuccess',
          itemValue:
            'Thank you for reaching out. Your message has been received and we will address it promptly.',
          langCode: 'en',
        },
        emailUsReturnHome: {
          itemId: 26,
          itemName: 'emailUsReturnHome',
          itemValue: 'Return home',
          langCode: 'en',
        },
        trackingTitle: {
          itemId: 27,
          itemName: 'trackingTitle',
          itemValue: 'Order track',
          langCode: 'en',
        },
        trackingOrderNumber: {
          itemId: 27,
          itemName: 'trackingOrderNumber',
          itemValue: 'Order number',
          langCode: 'en',
        },
        trackingOrderNumberReminder: {
          itemId: 28,
          itemName: 'trackingOrderNumberReminder',
          itemValue: 'Order number (#123)',
          langCode: 'en',
        },
        trackingEmailOrPhone: {
          itemId: 29,
          itemName: 'trackingEmailOrPhone',
          itemValue: 'Email or Phone',
          langCode: 'en',
        },
        trackingNumber: {
          itemId: 30,
          itemName: 'trackingNumber',
          itemValue: 'Tracking number',
          langCode: 'en',
        },
        trackingNumberReminder: {
          itemId: 30,
          itemName: 'trackingNumberReminder',
          itemValue: 'Tracking number',
          langCode: 'en',
        },
        trackingButton: {
          itemId: 31,
          itemName: 'trackingButton',
          itemValue: 'Track',
          langCode: 'en',
        },
      },
      orderTrackingApps: [],
    },
  },
};
export const updateShopSettingsMockResponses = {
  '/api/brand/v1/shop/updateShopSettings': {
    ...requestBaseData,
    data: {
      success: true,
    },
  },
};
